export const INVOICE_STATUS = {
  offen: { label: "Offen", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300" },
  erstellt: { label: "Erstellt", cls: "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300" },
  versendet: { label: "Versendet", cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  bezahlt: { label: "Bezahlt", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
};

export const INVOICE_TYPES = {
  anzahlung: "Anzahlung",
  abschlag: "Abschlagszahlung",
  schluss: "Schlussrechnung",
  sonstige: "Sonstige",
};

export const STANDARD_TYPES = ["anzahlung", "abschlag", "schluss"];

export function fmtEUR(n) {
  if (n === null || n === undefined || n === "") return "–";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
}

export function fmtDate(s) {
  if (!s) return "–";
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString("de-DE");
}
